// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__-oJqq","icon":"SortAdornment_icon__1CJE2","up":"SortAdornment_up__qabUX","down":"SortAdornment_down__DMUY3","active":"SortAdornment_active__30zzv"};